export enum LayoutDirection {
  V = 'V',
  H = 'H',
}

export interface Layout {
  direction: LayoutDirection;
  items: Array<Layout | string>;
  name?: string;
}
